<template>
  <div
    class="w-full py-5 px-16 primary-color h-auto float-left shadow sticky top-0 z-50 flex max-h-16 items-center justify-center">
    <div class="message_notification">
      <i v-if="loggedIn" @click="access()" class="pi pi-bars side-menu" style="margin-right: 10px;margin-left: 10px;"></i>
    </div>

    <div class="flex justify-between align-middle w-full max-w-fix">
      <router-link to="/">
        <h2 class="text-white font-normal text-lg text-left w-max float-left noselect">
          {{ $t("general.snap_drive") }}
        </h2>
      </router-link>
      <div class="flex flex-row justify-between items-center gap-3">

        <a v-if="loggedIn">
          <div class="spring-spinner" v-if="loggingOut">
            <div class="spring-spinner-part top">
              <div class="spring-spinner-rotator"></div>
            </div>
            <div class="spring-spinner-part bottom">
              <div class="spring-spinner-rotator"></div>
            </div>
          </div>
          <img src="./assets/icons/logout.svg" @click="logout" v-else />
        </a>

        <LangSelector />
      </div>
    </div>
  </div>
  <Sidebar v-model:visible="visibleLeft" :position="$store.getters.selectedLanguage === 'ar' ? 'right' : 'left'" dismissable :showCloseIcon="false" style="padding: 0">
    <PanelMenu class="test" header="Header" :model="items" />
  </Sidebar>
  <router-view />
  <Dialog />
  <notifications position="bottom left" max="10" class="notification" closeOnClick="true" />
</template>

<script>
import LangSelector from "./components/LangSelector.vue";
import { onMounted, onUnmounted } from "vue";
import axios from "axios";
import Dialog from "@/components/Dialog.vue";
import Sidebar from "primevue/sidebar";
import "primeicons/primeicons.css";
import PanelMenu from "primevue/panelmenu";
import socketEventsMixin from "@/mixins/socketEventsMixin";


export default {
  name: "App",
  mixins: [socketEventsMixin],
  events() {
    return {

      "Passengers:three_ds_new": this.three_ds,
    };
  },
  components: {
    LangSelector,
    Dialog,
    Sidebar,
    PanelMenu,
  },
  computed: {
    items() {
      let itms = [
        {
          label: this.$t("general.place_order"),
          icon: "pi pi-phone",
          command: () => {
            this.$router.push("/");
            this.visibleLeft = false;
          },
        },
        {
          label:  this.$t('general.upcoming_orders'),
          icon: "pi pi-clock",
          command: () => {
            this.$router.push("/upcoming-orders");
            this.visibleLeft = false;
          },
        },
        {
          label: this.$t('general.order_history'),
          icon: "pi pi-clock",
          command: () => {
            this.$router.push("/order-history");
            this.visibleLeft = false;
          },
        },

      ];

      return itms;
    },

  },
  data(vm) {
    return {
      loggedIn: false,
      loggingOut: false,
      visibleLeft: false,
      booking: null,
    };
  },
  beforeMount() {
    this.loggedIn = this.$store.getters.loggedIn;
    document.addEventListener("keydown", function (e) {
      if (e.which === 38 || e.which === 40) {
        e.preventDefault();
      }
    });
    if (this.loggedIn)
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + this.$store.state.token;
    this.$i18n.locale = this.$store.getters.selectedLanguage;
  },
  mounted() {

  },

  watch: {
    "$store.getters.loggedIn": {
      handler: function (val) {
        this.loggedIn = val;

      },
      immediate: true,
    },
    '$store.getters.selectedLanguage': {
      immediate: true,
      handler(lang) {
        document.documentElement.setAttribute(
          "dir",
          lang === "ar" ? "rtl" : "ltr"
        );

      }
    }

  },
  methods: {

    access() {
      this.visibleLeft = true;
    },

    logout() {
      this.loggingOut = true;
      this.$store
        .dispatch("destroyToken")
        .then(() => {
          console.log("done3");
          this.$router.push({ name: "Login" });
          this.loggingOut = false;
          this.loggedIn = false;
        })
        .catch(() => {
          this.loggingOut = false;
          this.loggedIn = true;
        });
    },

  },
};
</script>

<style lang="scss" scoped>
a {
  cursor: pointer;
}

.side-menu {
  color: white;
  margin-right: 5px;
}

.side-menu {
  cursor: pointer;
}

.message-text {
  font-size: 16px;
}

.parent-div {
  position: relative;
  display: inline-block;
}

.primary-color {
  background-color: #27a432;
}

.notification-circle {
  position: absolute;
  display: inline-block;
  top: -7px;
  right: -8px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: red;
  text-align: center;
  color: white;
  font-size: 12px;
  /* Adjust font size as needed */
  line-height: 20px;
  /* Vertically align the number */
}
</style>
